<script setup lang="ts">
import store from '@/store';

const props = defineProps<{
  item: {
    message: string;
    color: string;
  };
  index: number;
}>();

function removeSuccess() {
  store.commit('removeSuccess', props.index);
}

function getIconByColorStatus(color = props.item.color) {
  if (color === 'error') return 'mdi-alert-circle';
  return 'mdi-check-circle';
}
</script>

<template>
  <v-alert
    :type="item.color"
    border="left"
    prominent
    transition="fade-transition"
    dismissible
    class="success-item mb-1"
    @input="removeSuccess"
  >
    <template #prepend>
      <v-icon large>
        {{ getIconByColorStatus() }}
      </v-icon>
    </template>
    <v-row style="max-width: 250px" class="mx-4 text-wrap">
      {{ item.message }}
    </v-row>
  </v-alert>
</template>

<style scoped lang="scss">
.success-item {
  border-radius: 8px !important;
}

.v-alert__content {
  z-index: 9999 !important;
}
</style>
